import script from "./AmazonTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./AmazonTip.vue?vue&type=script&lang=ts&setup=true"

import "./AmazonTip.vue?vue&type=style&index=0&id=53803bc6&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53803bc6"]])

export default __exports__